import api from './api';

// Employee APIs
export const employeeApi = {
  getAll: (params) => api.get('/employees', { params }),
  getById: (id) => api.get(`/employees/${id}`),
  create: (data) => api.post('/employees', data),
  update: (id, data) => api.put(`/employees/${id}`, data),
  delete: (id) => api.delete(`/employees/${id}`),
  getStats: () => api.get('/employees/stats'),
  onboard: (id) => api.post(`/employees/${id}/onboard`),
  offboard: (id, data) => api.post(`/employees/${id}/offboard`, data)
};

// System APIs
export const systemApi = {
  getAll: (params) => api.get('/systems', { params }),
  getById: (id) => api.get(`/systems/${id}`),
  create: (data) => api.post('/systems', data),
  update: (id, data) => api.put(`/systems/${id}`, data),
  delete: (id) => api.delete(`/systems/${id}`),
  initialize: () => api.post('/systems/initialize')
};

// Access APIs
export const accessApi = {
  getAll: (params) => api.get('/access', { params }),
  getMatrix: (params) => api.get('/access/matrix', { params }),
  getStats: () => api.get('/access/stats'),
  grant: (data) => api.post('/access/grant', data),
  revoke: (data) => api.post('/access/revoke', data),
  batchGrant: (data) => api.post('/access/batch-grant', data)
};

// Audit APIs
export const auditApi = {
  getAll: (params) => api.get('/audit', { params }),
  getStats: (params) => api.get('/audit/stats', { params }),
  getEmployeeLogs: (employeeId, params) => api.get(`/audit/employee/${employeeId}`, { params }),
  export: (params) => api.get('/audit/export', { params, responseType: 'blob' })
};

export default {
  employee: employeeApi,
  system: systemApi,
  access: accessApi,
  audit: auditApi
};
